let myModal = document.getElementsByClassName("modal");
if(myModal.length > 0) {

// https://www.freecodecamp.org/news/how-to-build-a-modal-with-javascript/
// First Modal
const modal = document.querySelector(".modal");
const overlay = document.querySelector(".overlay");
const openModalBtn = document.querySelector(".btn-open");
const closeModalBtn = document.querySelector(".btn-close");
const body = document.body;

// close modal function
const closeModal = function () {
  modal.classList.add("hidden");
  overlay.classList.add("hidden");
  body.classList.remove("fixed");
};

// close the modal when the close button and overlay is clicked
closeModalBtn.addEventListener("click", closeModal);
overlay.addEventListener("click", closeModal);

// close modal when the Esc key is pressed
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape" && !modal.classList.contains("hidden")) {
    closeModal();
  }
});

// open modal function
const openModal = function () {
  modal.classList.remove("hidden");
  overlay.classList.remove("hidden");
  body.classList.add("fixed");
};
// open modal event
openModalBtn.addEventListener("click", openModal);


// Second Modal
const modal2 = document.querySelector(".modal2");
const overlay2 = document.querySelector(".overlay2");
const openModalBtn2 = document.querySelector(".btn-open2");
const closeModalBtn2 = document.querySelector(".btn-close2");

// close modal function
const closeModal2 = function () {
  modal2.classList.add("hidden");
  overlay2.classList.add("hidden");
  body.classList.remove("fixed");
};

// close the modal when the close button and overlay is clicked
closeModalBtn2.addEventListener("click", closeModal2);
overlay2.addEventListener("click", closeModal2);

// close modal when the Esc key is pressed
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape" && !modal2.classList.contains("hidden")) {
    closeModal2();
  }
});

// open modal function
const openModal2 = function () {
  modal2.classList.remove("hidden");
  overlay2.classList.remove("hidden");
  body.classList.add("fixed");
};
// open modal event
openModalBtn2.addEventListener("click", openModal2);
}

const swiper = new Swiper('.product-details .swiper', {
  // Optional parameters
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1,
  spaceBetween: 20,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});


// SORT BY DROP DOWN UPDATER 

  Shopify.queryParams = {};

  // Preserve existing query parameters
  if (location.search.length) {
    var params = location.search.substr(1).split('&');

    for (var i = 0; i < params.length; i++) {
      var keyValue = params[i].split('=');

      if (keyValue.length) {
        Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
      }
    }
  }

  // Update sort_by query parameter on select change
  document.querySelector('#sort-by').addEventListener('change', function(e) {
    var value = e.target.value;

    Shopify.queryParams.sort_by = value;
    location.search = new URLSearchParams(Shopify.queryParams).toString();
  });


// KLAVIYO WAITLIST POP UP BUTTON 

//  document.querySelector('.klaviyo_form_trigger1').addEventListener('click', function (){
//    window._klOnsite = window._klOnsite || []; 
//    window._klOnsite.push(['openForm', 'WA3L53']);
//    });

//   var waitBtns = document.querySelectorAll('.klaviyo_form_trigger1');
//    waitBtns.forEach(function(wt){
//      wt.addEventListener('click', function (){
//        window._klOnsite = window._klOnsite || []; 
//        window._klOnsite.push(['openForm', 'WA3L53']);
//      });
//    });